'use strict';

// Profile Databag
define('profile_databag',['jquery.amd', 'databag', 'deviceInfo', 'underscore', 'cookieConsentConfiguration'], function profile_databag($, Databag, deviceInfo, _, cookieConsentConfig) {
  var profile = new Databag({name: 'nvtag'}),
    hasCheckedAllowListAndFetch = false;

  function resetCheckedAllowList() {
    hasCheckedAllowListAndFetch = false;
  }

  function checkAllowListAndFetch() {
    if (hasCheckedAllowListAndFetch || !cookieConsentConfig.areFunctionalCookiesAccepted()) {
      return;
    }

    hasCheckedAllowListAndFetch = true;

    $.jsonp({
      cache: !deviceInfo.ie,
      url: profile.databag_root + 'identity'
    }).then(function (id) {
      profile.allowlisted = true;
      if (id) {
        profile.set('id', id, { silent: true });
      }
    }, function () {
      profile.allowlisted = false;
      // this probably isn't required, but there is a race condition that we want to handle.
      $('.ngp-form .FastAction').remove();
    }).always(function () {
      profile.fetch({ prefill: true });
    });
  }

  profile.resetCheckedAllowList = _.bind(resetCheckedAllowList);
  profile.checkAllowListAndFetch = _.bind(checkAllowListAndFetch);
  return profile;
});

